import { Avatar } from '@mantine/core';
import classes from './Avatar.module.css';

export const AvatarConfig = Avatar.extend({
  classNames: {
    root: classes.root,
    image: classes.image,
  },
});
